import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Label, Row } from "reactstrap";
import {
  CON_WORKING_DAY_OF_WEEK,
  CON_WORKING_DAYS,
  CON_WORKING_SALARY,
  CON_WORKING_TIME,
  LIST_OPTION_EXPERIENCE,
  LIST_OPTION_SALARY_TYPE_USER,
} from "helpers/constans";
import DropdownHours from "components/Common/DropdownHours";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import { NumericFormat } from "react-number-format";
import TalentExperienceArray from "components/Common/TalentExperienceArray";
import DatePicker from "react-datepicker";
import ModalRegion from "components/Common/ModalRegion";

registerLocale("en", en);
registerLocale("ko", ko);

interface Props {
  formik: any;
  regions?: any;
}

const WorkingConditions = ({ formik, regions = [] }: Props) => {
  const { t } = useTranslation();

  const toggleDay = (dayValue: number) => {
    const currentDays = formik.values.workingDays || [];

    const newDays = currentDays?.includes(dayValue)
      ? currentDays.filter((d: any) => d !== dayValue)
      : [...currentDays, dayValue];

    formik.setFieldValue("workingDays", newDays);
  };

  const togglePreferredLocation = (location: any) => {};

  const [isOpenRegion, setIsOpenRegion] = useState<boolean>(false);
  const handleConfirmRegion = (lstRegion: any) => {
    formik.setFieldValue("regions", lstRegion);
    setIsOpenRegion(false);
  };

  const handleCloseRegion = () => {
    setIsOpenRegion(false);
  };

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Working Conditions")}
        </span>
        <Row>
          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="titleKoreaInput" className="form-label">
                {t("Experience Level")} <span className="text-danger"></span>
              </Label>

              <div className="d-flex justify-content-start align-items-center">
                {LIST_OPTION_EXPERIENCE?.map((item) => {
                  return (
                    <div
                      className="d-flex justify-content-start align-items-center form-check me-3"
                      key={`experience-${String(item?.value)}`}
                      onClick={() => {
                        formik?.setFieldValue("hasExperience", item.value);
                      }}
                    >
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="experience_level"
                        id={`experience-${String(item?.value)}`}
                        value={item?.value}
                        checked={
                          item?.value == Number(formik?.values?.hasExperience)
                        }
                        style={{ minWidth: "16px" }}
                        onChange={(event) => {
                          formik?.setFieldValue("hasExperience", item.value);
                        }}
                      />
                      <label
                        className="form-check-label position-relative"
                        htmlFor={`experience-${String(item?.value)}`}
                      >
                        {t(item?.label)}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>

          {formik?.values?.hasExperience === 1 && (
            <Col lg={12}>
              <div className="mb-3">
                <TalentExperienceArray formik={formik} />
              </div>
            </Col>
          )}

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="titleKoreaInput" className="form-label">
                {t("Preferred Working Days")}{" "}
              </Label>

              <div className="d-flex justify-content-start align-items-center">
                {CON_WORKING_DAYS?.map((item, index) => {
                  return (
                    <div
                      className="d-flex justify-content-start align-items-center form-check me-3"
                      key={index}
                      onClick={() => {
                        formik?.setFieldValue(
                          "isFlexibleWorkingDay",
                          item.value
                        );
                      }}
                    >
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="working_days"
                        id={`working_days-${String(item?.value)}`}
                        // value={item?.value}
                        checked={
                          item?.value === formik?.values?.isFlexibleWorkingDay
                        }
                        style={{ minWidth: "16px" }}
                        onChange={(event) => {
                          formik?.setFieldValue(
                            "isFlexibleWorkingDay",
                            item.value
                          );
                        }}
                      />
                      <label
                        className="form-check-label position-relative"
                        htmlFor={`working_days-${String(item?.value)}`}
                      >
                        {t(item?.label)}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>

          {formik?.values?.isFlexibleWorkingDay === false && (
            <Col lg={12}>
              <div className="d-flex gap-2 mb-3">
                {CON_WORKING_DAY_OF_WEEK.map((day) => (
                  <button
                    key={day.value}
                    type="button"
                    onClick={() => toggleDay(day.value)}
                    style={{ border: "unset" }}
                    className={`px-4 py-2 rounded-md ${
                      Array?.isArray(formik.values?.workingDays) && formik.values?.workingDays?.includes(day?.value)
                        ? "bg-primary text-white"
                        : "text-gray-300"
                    }`}
                  >
                    {t(day.label)}
                  </button>
                ))}
              </div>
              {formik.errors?.workingDays ? (
                <div className="text-danger mt-2 mb-3">
                  {formik.errors.workingDays}
                </div>
              ) : null}
            </Col>
          )}

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="titleKoreaInput" className="form-label">
                {t("Preferred Working Time")}{" "}
              </Label>

              <div className="d-flex justify-content-start align-items-center">
                {CON_WORKING_TIME?.map((item, index) => {
                  return (
                    <div
                      className="d-flex justify-content-start align-items-center form-check me-3"
                      key={index}
                      onClick={() => {
                        formik?.setFieldValue(
                          "isFlexibleWorkingTime",
                          item.value
                        );
                      }}
                    >
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="working_time"
                        id={`working_time-${String(item?.value)}`}
                        // value={item?.value}
                        checked={
                          item?.value === formik?.values?.isFlexibleWorkingTime
                        }
                        style={{ minWidth: "16px" }}
                        onChange={(event) => {
                          formik?.setFieldValue(
                            "isFlexibleWorkingTime",
                            item.value
                          );
                        }}
                      />
                      <label
                        className="form-check-label position-relative"
                        htmlFor={`working_time-${String(item?.value)}`}
                      >
                        {t(item?.label)}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>

          {formik?.values?.isFlexibleWorkingTime === false && (
            <Col lg={12} className="date-picker-wrapper-custom">
              <Row className="mb-3 d-flex align-items-center">
                <Col lg={3} style={{ maxWidth: "160px" }}>
                  <DropdownHours
                    name="workingTimeFrom"
                    initialValue={
                      formik?.values?.workTimeRange?.workingTimeFrom || ""
                    }
                    onChangeSelect={(value: any) => {
                      formik.setFieldValue(
                        `workTimeRange.workingTimeFrom`,
                        value?.value
                      );
                    }}
                  />
                </Col>
                <Col
                  lg={1}
                  style={{
                    paddingLeft: "0",
                    paddingRight: "0",
                    textAlign: "center",
                    maxWidth: "2px",
                  }}
                >
                  <span>~</span>
                </Col>
                <Col lg={3} style={{ maxWidth: "160px" }}>
                  <DropdownHours
                    name="workingTimeTo"
                    initialValue={formik?.values?.workTimeRange?.workingTimeTo}
                    onChangeSelect={(value: any) => {
                      formik.setFieldValue(
                        `workTimeRange.workingTimeTo`,
                        value?.value
                      );
                    }}
                  />
                </Col>

                {formik.touched.workTimeRange && formik.errors.workTimeRange ? (
                  <div className="text-danger mt-2">
                    {formik.errors.workTimeRange}
                  </div>
                ) : null}
              </Row>
            </Col>
          )}

          <Col md={6} lg={4}>
            <div className="mb-3">
              <Label htmlFor="work_period" className="form-label">
                {t("Preferred Start Date")}
              </Label>
              <div className="w-100">
                <DatePicker
                  name={"startDate"}
                  className="form-control"
                  selected={formik?.values?.startDate}
                  placeholderText={t("Start Date")}
                  onChange={(date: any) => {
                    formik.setFieldValue("startDate", date);
                  }}
                  dateFormat="yyyy-MM-dd"
                  isClearable={true}
                />
              </div>
              {formik.touched.startDate && formik.errors.startDate ? (
                <div className="text-danger mt-2">
                  {formik.errors.startDate}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="salary" className="form-label">
                {t("Salary")}{" "}
              </Label>

              <div className="d-flex justify-content-start align-items-center">
                {CON_WORKING_SALARY?.map((item, index) => {
                  return (
                    <div
                      className="d-flex justify-content-start align-items-center form-check me-3"
                      key={index}
                      onClick={() => {
                        formik?.setFieldValue("isSalaryNegotiable", item.value);
                      }}
                    >
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name="working_salary"
                        id={`working_salary-${String(item?.value)}`}
                        // value={item?.value}
                        checked={
                          item?.value === formik?.values?.isSalaryNegotiable
                        }
                        style={{ minWidth: "16px" }}
                        onChange={(event) => {
                          formik?.setFieldValue(
                            "isSalaryNegotiable",
                            item.value
                          );
                          console.log(item.value);
                        }}
                      />
                      <label
                        className="form-check-label position-relative"
                        htmlFor={`working_salary-${String(item?.value)}`}
                      >
                        {t(item?.label)}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>

          {formik?.values?.isSalaryNegotiable === false && (
            <Col lg={12} className="date-picker-wrapper-custom">
              <Row className="mb-3 d-flex">
                <Col md={3} lg={3}>
                  <div className="mb-3">
                    <Label htmlFor="contact_name" className="form-label">
                      {t("Salary Type")} <span className="text-danger">*</span>
                    </Label>
                    <DropdownOptionNew
                      name="expectedSalaryType"
                      dataList={LIST_OPTION_SALARY_TYPE_USER || []}
                      placeholder={`${t("Salary Type")}...`}
                      className="dropdown-status-rounded"
                      classNamePrefix="name-prefix"
                      initialValue={formik?.values?.expectedSalaryType}
                      onChangeSelect={(e: any) =>
                        formik.setFieldValue("expectedSalaryType", e?.value)
                      }
                      isHasOptionAll={false}
                    />
                    {formik.touched.expectedSalaryType &&
                    formik.errors.expectedSalaryType ? (
                      <div className="text-danger mt-2">
                        {formik.errors.expectedSalaryType}
                      </div>
                    ) : null}
                  </div>
                </Col>

                <Col md={6} lg={6}>
                  <div className="mb-3">
                    <Label htmlFor="expectedSalary" className="form-label">
                      {t("Amount")}
                      <span className="text-danger"> *</span>
                    </Label>

                    <div className="d-flex mb-2 gap-2 align-items-center">
                      <NumericFormat
                        className="form-control"
                        value={formik?.values?.expectedSalary || ""}
                        placeholder={t("Amount")}
                        allowLeadingZeros
                        thousandSeparator=","
                        isAllowed={(values) => {
                          const { formattedValue, floatValue } = values;
                          return (
                            formattedValue === "" ||
                            (floatValue || 0) <= 9999999999
                          );
                        }}
                        onValueChange={(values: any) => {
                          const { value } = values;
                          formik.setFieldValue("expectedSalary", value);
                        }}
                      />
                      <div>₩</div>
                    </div>

                    {formik.touched.expectedSalary &&
                    formik.errors.expectedSalary ? (
                      <div className="text-danger mt-2">
                        {formik.errors.expectedSalary}
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </Col>
          )}

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="description" className="form-label">
                {t("Preferred Work Location")}
              </Label>
              <div className="d-flex gap-2 mb-3 flex-wrap">
                {formik?.values?.regions?.map((location: any, index: any) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => togglePreferredLocation(location)}
                    style={{ border: "unset" }}
                    className={`px-4 py-2 rounded-md bg-primary text-white`}
                  >
                    {location?.label}
                  </button>
                ))}
                <button
                  type="button"
                  onClick={() => setIsOpenRegion(true)}
                  style={{ border: "unset" }}
                  className={`px-4 py-2 rounded-md text-gray-300`}
                >
                  {t("Select Region")}
                </button>
              </div>
            </div>
          </Col>

          <Col md={6} lg={4}>
            <div className="mb-3">
              <Label htmlFor="work_period" className="form-label">
                {t("Preferred Contact Time")}
              </Label>
              <div className="w-100">
                <Input
                  name="workplace"
                  type="text"
                  className="form-control"
                  id="workplace"
                  placeholder={t("Preferred Contact Time")}
                  value={formik?.values?.preferredTimeToContact || ""}
                  onChange={(event: any) =>
                    formik.setFieldValue(
                      "preferredTimeToContact",
                      event?.target?.value
                    )
                  }
                />
              </div>
              {formik.touched.preferredTimeToContact &&
              formik.errors.preferredTimeToContact ? (
                <div className="text-danger mt-2">
                  {formik.errors.preferredTimeToContact}
                </div>
              ) : null}
            </div>
          </Col>
        </Row>
        {isOpenRegion && (
          <ModalRegion
            regions={regions}
            onConfirm={handleConfirmRegion}
            onClose={handleCloseRegion}
            lstRegionSelected={formik?.values?.regions}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default WorkingConditions;
